import { render, staticRenderFns } from "./Police.vue?vue&type=template&id=85329538&scoped=true&"
import script from "./Police.vue?vue&type=script&lang=js&"
export * from "./Police.vue?vue&type=script&lang=js&"
import style0 from "./Police.vue?vue&type=style&index=0&id=85329538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85329538",
  null
  
)

export default component.exports